import React, { useState, useEffect } from 'react';
import TextField from 'components/TextField';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from 'components/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {
  Heading,
  AddedProduct,
  Container,
  Update,
  EUFieldWrapper,
} from 'styles/pages/edit-products/editProductSizes';

const EditProductSizes = ({ product, updateProductSizes }) => {
  const [sizes, setSizes] = useState(product?.Sizes);
  const printProviders = product?.PrintProviders;

  const isAuPrintProvider = printProviders?.find(
    (p) => p?.ProviderName === 'AU'
  );

  const isEuPrintProvider = printProviders?.find(
    (p) => p?.ProviderName === 'EU'
  );

  const whitePriceCondition =
    product?.Product?.PrintType === 'DTG' ||
    product?.Product?.PrintType === 'EMB' ||
    product?.Product?.PrintType === 'DURASOFT';

  const markUpPercentage = !!isEuPrintProvider
    ? isEuPrintProvider?.markUpPercentage
    : !!isAuPrintProvider
    ? isAuPrintProvider?.markUpPercentage
    : 0;

  useEffect(() => {
    let newSizes = sizes;
    const printType = product?.Product?.PrintType;

    for (let i = 0; i < newSizes?.length; i++) {
      const key = [`${printType}Price`];
      const printTypePrice = newSizes[i][key];
      newSizes[i][key] = newSizes[i][key] || 0;
    }

    setSizes(() => newSizes);
  }, []);

  return (
    <Container>
      <Heading>
        <h3>Product Sizes</h3>
        <IconButton
          aria-label="delete"
          color="secondary"
          onClick={() =>
            setSizes([
              ...sizes,
              {
                Name: '',
                ColoredPrice: '',
                ID: moment().unix() + sizes?.length,
                visible: true,
              },
            ])
          }
        >
          <AddCircleIcon style={{ fontSize: 30 }} />
        </IconButton>
      </Heading>
      <div>
        {sizes?.map((size, index) => (
          <React.Fragment key={`EditProductSizes${index}`}>
            <AddedProduct style={{ display: 'flex', flexDirection: 'row' }}>
              <div>
                {size?.visible === false ? (
                  <VisibilityOffIcon
                    style={{ color: 'red', cursor: 'pointer' }}
                    onClick={() => {
                      setSizes(
                        sizes?.map((s, i) => {
                          if (i != index) {
                            return s;
                          }
                          return {
                            ...s,
                            visible: true,
                          };
                        })
                      );
                    }}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ color: 'lightseagreen', cursor: 'pointer' }}
                    onClick={() => {
                      setSizes(
                        sizes?.map((s, i) => {
                          if (i != index) {
                            return s;
                          }
                          return {
                            ...s,
                            visible: false,
                          };
                        })
                      );
                    }}
                  />
                )}
              </div>

              <TextField
                label="Name"
                value={size?.Name}
                size="small"
                onChange={(Name) => {
                  setSizes(
                    sizes?.map((s, i) => {
                      if (i != index) {
                        return s;
                      }
                      return {
                        ...s,
                        Name,
                      };
                    })
                  );
                }}
              />

              {(!!isAuPrintProvider || !!isEuPrintProvider) && (
                <EUFieldWrapper>
                  {whitePriceCondition && (
                    <TextField
                      label="Original White Price"
                      value={size?.originalWhitePrice?.toString() || 0}
                      size="small"
                      type="number"
                      onChange={(originalWhitePrice) => {
                        const v = Number(originalWhitePrice);
                        setSizes(
                          sizes?.map((s, i) => {
                            if (i !== index) {
                              return s;
                            }
                            return {
                              ...s,
                              originalWhitePrice: v,
                              WhitePrice: Number(
                                ((markUpPercentage * v) / 100 + v).toFixed(2)
                              ),
                            };
                          })
                        );
                      }}
                    />
                  )}

                  <TextField
                    label="Original Colored Price"
                    value={size?.originalColoredPrice?.toString() || 0}
                    size="small"
                    type="number"
                    onChange={(originalColoredPrice) => {
                      const v = Number(originalColoredPrice);
                      setSizes(
                        sizes?.map((s, i) => {
                          if (i !== index) {
                            return s;
                          }
                          return {
                            ...s,
                            originalColoredPrice: v,
                            ColoredPrice: Number(
                              ((markUpPercentage * v) / 100 + v).toFixed(2)
                            ),
                          };
                        })
                      );
                    }}
                  />

                  <TextField
                    label={`Original ${product?.Product?.PrintType} Price`}
                    value={
                      size?.[
                        `${product?.Product?.PrintType}OriginalPrice`
                      ]?.toString() || '0'
                    }
                    size="small"
                    type="number"
                    onChange={(p) => {
                      const v = Number(p);
                      setSizes(
                        sizes?.map((s, i) => {
                          if (i !== index) {
                            return s;
                          }
                          return {
                            ...s,
                            [`${product?.Product?.PrintType}OriginalPrice`]: v,
                            [`${product?.Product?.PrintType}Price`]: Number(
                              ((markUpPercentage * v) / 100 + v).toFixed(2)
                            ),
                          };
                        })
                      );
                    }}
                  />
                </EUFieldWrapper>
              )}

              {whitePriceCondition && (
                <TextField
                  label="White Price"
                  value={size?.WhitePrice?.toString()}
                  size="small"
                  type="number"
                  disabled={!!isAuPrintProvider || !!isEuPrintProvider}
                  onChange={(WhitePrice) => {
                    setSizes(
                      sizes?.map((s, i) => {
                        if (i != index) {
                          return s;
                        }
                        return {
                          ...s,
                          WhitePrice: Number(WhitePrice),
                        };
                      })
                    );
                  }}
                />
              )}

              <TextField
                label="Colored Price"
                value={size?.ColoredPrice?.toString()}
                size="small"
                type="number"
                disabled={!!isAuPrintProvider || !!isEuPrintProvider}
                onChange={(ColoredPrice) => {
                  setSizes(
                    sizes?.map((s, i) => {
                      if (i != index) {
                        return s;
                      }
                      return {
                        ...s,
                        ColoredPrice: Number(ColoredPrice),
                      };
                    })
                  );
                }}
              />

              <TextField
                label={`${product?.Product?.PrintType} Price`}
                value={
                  size?.[`${product?.Product?.PrintType}Price`]?.toString() ||
                  '0'
                }
                disabled={!!isAuPrintProvider || !!isEuPrintProvider}
                size="small"
                type="number"
                onChange={(p) => {
                  setSizes(
                    sizes?.map((s, i) => {
                      if (i != index) {
                        return s;
                      }
                      return {
                        ...s,
                        [`${product?.Product?.PrintType}Price`]: Number(p),
                      };
                    })
                  );
                }}
              />

              {product?.RemainingDecorativeTechniques?.map((v) => (
                <TextField
                  label={`${v?.DisplayName} Price`}
                  value={size?.[`${v?.DisplayName}Price`]?.toString() || '0'}
                  size="small"
                  disabled={!!isAuPrintProvider || !!isEuPrintProvider}
                  type="number"
                  onChange={(p) => {
                    setSizes(
                      sizes?.map((s, i) => {
                        if (i != index) {
                          return s;
                        }
                        return {
                          ...s,
                          [`${v?.DisplayName}Price`]: Number(p),
                        };
                      })
                    );
                  }}
                />
              ))}

              <IconButton
                aria-label="delete"
                color="secondary"
                onClick={() => setSizes(sizes?.filter((s, i) => i != index))}
              >
                <DeleteIcon />
              </IconButton>
            </AddedProduct>
            <Divider />
          </React.Fragment>
        ))}
      </div>
      <Update>
        <Button
          title="Update"
          disabled={!sizes?.length}
          onClick={() => {
            const payload = {
              ID: product?.Product?.ID,
              sizeData: sizes,
            };

            updateProductSizes(payload);
          }}
        />
      </Update>
    </Container>
  );
};

export default EditProductSizes;
